import React, {useEffect} from 'react'
import {observer} from 'mobx-react-lite'
import {SubmitHandler, useForm} from 'react-hook-form'
import {Box, Button, Stack, Text} from '../../../vanilla'
import {AddressFields} from '../../../components/forms'
import {useBasketStore, useCustomerStore} from '../../../store/hooks/useStore'
import {OrderAddress} from '../../../types/store/basket'
import {editShippingAddressFormField} from '../styles.css'
import { CustomerAddress } from '../../../store/CustomerStore'
import { AddressFormFields } from '../../../types/forms'

interface EditAddressFormProps {
  setDeliveryAddress: (address: OrderAddress, saveAddress?: boolean) => void
  cleanupFunction: (() => void) | null
}

export const EditAddressForm = observer(
  ({setDeliveryAddress, cleanupFunction = null}: EditAddressFormProps) => {
    const {shippingAddress} = useBasketStore()
    const {addresses} = useCustomerStore()

    const customerAddressSelected = addresses.find(
      (address) => address.addressId === shippingAddress?.c_customerAddressID
    )

    const form = useForm<AddressFormFields>({mode: 'onBlur'})

    useEffect(() => {
      if (shippingAddress) {
        form.reset({
          title: shippingAddress.title?.toLowerCase() || '',
          firstName: shippingAddress.firstName || '',
          lastName: shippingAddress.lastName || '',
          phone: shippingAddress.phone || '',
          address1: shippingAddress.address1 || '',
          address2: shippingAddress.address2 || '',
          postalCode: shippingAddress.postalCode || '',
          city: shippingAddress.city || '',
          stateCode: shippingAddress.stateCode || '',
          searchForAddress: shippingAddress.postalCode || '',
          countryCode: shippingAddress.countryCode || '',
          addressId: customerAddressSelected?.addressId || '',
          preferred: customerAddressSelected?.preferred || false,
        })
      }
    }, [shippingAddress])

    const onSubmit: SubmitHandler<CustomerAddress> = async ({searchForAddress, ...data}) => {
      if (setDeliveryAddress && typeof setDeliveryAddress === 'function') {
        await setDeliveryAddress({...data, addressId: customerAddressSelected?.addressId, c_updateSource: 'Book Delivery'}, true)
        if (cleanupFunction) {
          cleanupFunction()
        }
      }
    }

    return (
      <Stack bg="gray25" spacing="0px">
        <Box paddingX="24px" paddingTop="28px">
          <Text variant="text4">Edit this address</Text>
        </Box>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <AddressFields
            gap="0px"
            form={form}
            showDeliveryAvailability={false}
            enableEnterManually={false}
            inputGroupProps={{
              className: editShippingAddressFormField,
            }}
            formContainerPartsProps={{
              top: {bg: 'gray25', paddingBottom: '0px'},
              middle: {bg: 'gray25', paddingBottom: '0px'},
              bottom: {bg: 'gray25', paddingTop: '0px'},
            }}
          />
          <Box marginTop="16px" paddingX="24px" paddingBottom="52px">
            <Button variant="secondary" type="submit" size="sm">
              Save changes
            </Button>
          </Box>
        </form>
      </Stack>
    )
  }
)
